import { baseURL } from '@/config'

export default {
  // 接口地址
  baseURL: baseURL,
  isDev: true
}



// WEBPACK FOOTER //
// ./src/api/env.js